class SiteHeader extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.classes = {
      active: 'f-header__mega-active',
      headerScheme: this.dataset.headerColorScheme,
      dropdownScheme: this.dataset.dropdownColorScheme
    }
    this.headerSticky = document.querySelector('.site-header__wrapper')

    this.isRTL = document.documentElement.getAttribute('dir') === 'rtl'
    this.grandLinks = this.querySelectorAll('.f-site-nav__sub-item--has-child')
    this.grandLinks && this.grandLinks.forEach((item, index) => {
        this.handleGrandLinksPosition(item)
    })
  }

  calcDropdownHeight(dropdown) {
    if (!dropdown || !dropdown.classList.contains('f-site-nav__dropdown--mega')) {
    this.style.setProperty('--f-dropdown-height', '0px');
    return;
  }

    const rect = dropdown.getBoundingClientRect();
    this.style.setProperty('--f-dropdown-height', rect.height + 'px');
  }

  handleMegaItemActive() {
    this.classList.add(this.classes.active, this.classes.dropdownScheme)
    this.classList.remove(this.classes.headerScheme)
    document.documentElement.style.setProperty("--f-header-height", this.clientHeight + "px")
  }

  handleMegaItemDeactive() {
    this.classList.remove(this.classes.active, this.classes.dropdownScheme)
    this.classList.add(this.classes.headerScheme)
    document.documentElement.style.setProperty("--f-header-height", this.clientHeight + "px")
  }

  handleGrandLinksPosition(target) {
    const dropdownLV3 = target.querySelector('.f-site-nav__dropdown')
    if( dropdownLV3 ) {
      const rect = dropdownLV3.getBoundingClientRect()
      dropdownLV3.classList.remove('f-site-nav__dropdown-reversed')
      if( ( ! this.isRTL && document.documentElement.clientWidth < rect.x + rect.width + 10  )
        || ( this.isRTL && rect.x < 10 )
        ) {
          dropdownLV3.classList.add('f-site-nav__dropdown-reversed')
      }
    }
  }
}
customElements.define('site-header', SiteHeader)

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super()
  }

  connectedCallback() {
    this.header = this.closest('.site-header')
    this.classes = {
      itemActive: 'f-menu__item-active'
    }
    this.header.timeoutEnter = null
    this.header.timeoutLeave = null
  }

  onToggle(evt) {
    const { target } = evt

    const li = target.closest('.f-site-nav__item')
    const isOpen = this.mainDetailsToggle.open
    const isMega = li.classList.contains('f-site-nav__item--mega')

    if( ! isOpen ) {
      clearTimeout(this.header.timeoutEnter)
      li.classList.remove(this.classes.itemActive)
      this.header.timeoutLeave = setTimeout(() => {
        this.header.handleMegaItemDeactive()
      }, 160)
    } else {
      if ( isMega ) {
        clearTimeout(this.header.timeoutLeave)
        const dropdown = li.querySelector('.f-site-nav__dropdown')
        this.header.calcDropdownHeight( dropdown )
        this.header.handleMegaItemActive()
        this.header.timeoutEnter = setTimeout(() => {
          li.classList.add( this.classes.itemActive )
        }, 160)
      } else {
        li.classList.add( this.classes.itemActive )
      }
    }

    if (this.header.headerSticky) {
      this.header.headerSticky.preventReveal = this.mainDetailsToggle.open
    }
  }
}
customElements.define('header-menu', HeaderMenu);

class SiteNav extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.header = this.closest('.site-header')
    this.classes = {
      itemActive: 'f-menu__item-active',
      itemClosed: 'f-menu__item-closed'
    }

    this.megaItems = this.querySelectorAll('.f-site-nav__item--has-child');

    this.megaItems?.forEach((megaItem) => {
      const dropdown = megaItem.querySelector('.f-site-nav__dropdown--level2');
      this.setDropdownTabbable(dropdown, false);
    });

    this.timeoutEnter = null
    this.timeoutLeave = null
    this.isHover = this.header && this.header.classList.contains('show-dropdown-menu-on-hover')
    if( this.isHover ) {
      this.megaItems && this.megaItems.forEach((megaItem, index) => {
        megaItem.addEventListener('mouseenter', (evt) => this.onMenuItemEnter(evt, index))
        megaItem.addEventListener('mouseleave', (evt) => this.onMenuItemLeave(evt, index))
      })
    }

    this.megaItems && this.megaItems.forEach((megaItem) => {
      megaItem.addEventListener('focusout', (evt) => {
        const next = evt.relatedTarget;

        if (next && megaItem.contains(next)) return;

        this.closeMegaItem(megaItem, { returnFocus: false });
      })
    })

    this.megaItems && this.megaItems.forEach((megaItem) => {
      const trigger =
        megaItem.querySelector('summary.f-site-nav__link') ||
        megaItem.querySelector('a.f-site-nav__link');

      if (!trigger) return;

      megaItem.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;

        const isOpen = megaItem.classList.contains(this.classes.itemActive);
        if (!isOpen) return;

        e.preventDefault();
        e.stopPropagation();

        this.closeMegaItem(megaItem, { returnFocus: true });
        megaItem.classList.add(this.classes.itemClosed);
        trigger?.focus({ preventScroll: true });
      });

      const getDropdown = () => megaItem.querySelector('.f-site-nav__dropdown--level2');

      trigger.addEventListener('keydown', (e) => {
        const isSpace = e.key === ' ' || e.key === 'Spacebar';
        const isEscape = e.key === 'Escape';
        if (!isSpace && !isEscape) return;

        e.preventDefault();
        e.stopPropagation();

        const dropdown = getDropdown();
        if (!dropdown) return;

        // ESC closes immediately and returns focus
        if (isEscape) {
          const isOpen = megaItem.classList.contains(this.classes.itemActive);
          if (!isOpen) return;

          this.closeMegaItem(megaItem, { returnFocus: true });
          megaItem.classList.add(this.classes.itemClosed);
          return;
        }

        // SPACE toggles open/close (NO focusing here)
        const isOpen = megaItem.classList.contains(this.classes.itemActive);

        if (isOpen) {
          this.closeMegaItem(megaItem, { returnFocus: true });
          megaItem.classList.add(this.classes.itemClosed);
          trigger.dataset.pendingMegaFocus = '';
          return;
        }

        // OPEN MENU
        megaItem.classList.remove(this.classes.itemClosed);
        clearTimeout(this.timeoutLeave);
        this.header.calcDropdownHeight(dropdown);
        this.header.handleMegaItemActive();
        megaItem.classList.add(this.classes.itemActive);
        this.setDropdownTabbable(dropdown, true);

        // tell keyup to move focus into menu
        trigger.dataset.pendingMegaFocus = '1';
      });

      trigger.addEventListener('keyup', (e) => {
        const isSpace = e.key === ' ' || e.key === 'Spacebar';
        if (!isSpace) return;

        e.preventDefault();
        e.stopPropagation();

        // only do focus jump if we opened on keydown
        if (trigger.dataset.pendingMegaFocus !== '1') return;
        trigger.dataset.pendingMegaFocus = '';

        const dropdown = getDropdown();
        if (!dropdown) return;

        // if something closed it, bail
        if (!megaItem.classList.contains(this.classes.itemActive)) return;

        requestAnimationFrame(() => {
          let first = dropdown.querySelector('.f-site-nav__sub-item > a[href]');
          if (!first) {
            first = dropdown.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
          }
          if (!first) return;

          // ensure it's focusable if some tabindex lingering exists
          if (first.getAttribute('tabindex') === '-1') {
            first.removeAttribute('tabindex');
            first.removeAttribute('data-prev-tabindex');
          }

          first.focus({ preventScroll: true });

          // if theme steals focus back, force once more
          if (document.activeElement !== first) {
            setTimeout(() => first.focus({ preventScroll: true }), 0);
          }
        });
      });

    });
  }

  setDropdownTabbable(dropdown, enabled) {
    if (!dropdown) return;

    const focusables = dropdown.querySelectorAll(
      'a[href], button, input, select, textarea, [tabindex]'
    );

    console.log('focasables', focusables.length)

    focusables.forEach((el) => {
      const existing = el.getAttribute('tabindex');

      if (enabled) {
        const prev = el.getAttribute('data-prev-tabindex');

        if (prev !== null) {
          if (prev === '') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', prev);
          }
          el.removeAttribute('data-prev-tabindex');
        } else {
          if (existing === '-1') el.removeAttribute('tabindex');
        }
      } else {
        if (!el.hasAttribute('data-prev-tabindex')) {
          el.setAttribute('data-prev-tabindex', existing ?? '');
        }
        el.setAttribute('tabindex', '-1'); 
      }
    });

    dropdown.setAttribute('aria-hidden', enabled ? 'false' : 'true');
  }

  onMenuItemEnter(evt, index) {
    clearTimeout(this.timeoutLeave)

    const { target } = evt
    const dropdown = target.querySelector('.f-site-nav__dropdown')
    
    if( dropdown ) {
      this.setDropdownTabbable(dropdown, true);
      this.header.calcDropdownHeight( dropdown )
      this.header.handleMegaItemActive()
      this.timeoutEnter = setTimeout(() => {
        target.classList.add( this.classes.itemActive )
      }, 160)
    }
  }

  onMenuItemLeave(evt, index) {
    const { target } = evt

    const dropdown = target.querySelector('.f-site-nav__dropdown')
    
    if( dropdown ) {
      this.setDropdownTabbable(dropdown, false);
    }
    clearTimeout(this.timeoutEnter)
    target.classList.remove( this.classes.itemActive )
    this.timeoutLeave = setTimeout(() => {
      this.header.handleMegaItemDeactive()
    }, 80)
  }

  closeMegaItem(megaItem, { returnFocus = true } = {}) {
    const dropdown = megaItem.querySelector('.f-site-nav__dropdown--level2');
    const trigger = megaItem.querySelector(':scope > summary.f-site-nav__link') || megaItem.querySelector(':scope > a.f-site-nav__link');

    if (returnFocus && dropdown && dropdown.contains(document.activeElement)) {
      trigger?.focus();
    }

    clearTimeout(this.timeoutEnter);
    megaItem.classList.remove(this.classes.itemActive);

    if (dropdown) {
      this.setDropdownTabbable(dropdown, false); 
    }

    this.timeoutLeave = setTimeout(() => {
      this.header.handleMegaItemDeactive();
    }, 80);
  }

  closeMegaDropdowns() {
    clearTimeout(this.timeoutEnter);
    this.megaItems?.forEach((megaItem) => {
      this.closeMegaItem(megaItem, { returnFocus: false });
    });
  } 

  disconnectedCallback() {
    this.megaItems && this.megaItems.forEach((megaItem, index) => {
      megaItem.removeEventListener('mouseenter', (evt) => this.onMenuItemEnter(evt, index))
      megaItem.removeEventListener('mouseleave', (evt) => this.onMenuItemLeave(evt, index))
    })
  }
}
customElements.define('site-nav', SiteNav)